import CloseIcon from '@mui/icons-material/Close';
import { Button, IconButton, Paper, Stack, Typography } from '@mui/material';
import { useState } from 'react';

const LEAD_FORM_URL = 'https://www.nlc.consulting/restoration#lead-form';
const PHONE_HREF = 'tel:+18565224261';
const PHONE_LABEL = '(856) 522-4261';
const DISMISSED_KEY = 'nlc-talk-to-nick-dismissed';

const wasDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * The demo needs no sign-up, so nothing is captured unless a visitor is given a
 * way out to a person. Session-scoped dismissal: hidden for this visit, back on
 * the next one. Deliberately not a modal and not a gate.
 */
export default function TalkToNick() {
  const [hidden, setHidden] = useState(wasDismissed);

  if (hidden) return null;

  const dismiss = () => {
    try {
      sessionStorage.setItem(DISMISSED_KEY, '1');
    } catch {
      // Private browsing can throw; hiding for this render is enough.
    }
    setHidden(true);
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        // Clear of the sticky action bar the mobile views put at the bottom.
        bottom: { xs: 88, sm: 24 },
        right: { xs: 16, sm: 24 },
        zIndex: (theme) => theme.zIndex.snackbar - 1,
        maxWidth: 300,
        p: 2,
        pr: 5,
        borderRadius: 2,
      }}
    >
      <IconButton
        size="small"
        onClick={dismiss}
        aria-label="Hide this"
        sx={{ position: 'absolute', top: 4, right: 4 }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        Questions? Talk to Nick
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.5, color: 'text.secondary' }}>
        Poke around as long as you like. When you want to talk about your own company, here is the
        fastest way.
      </Typography>
      <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
        <Button
          size="small"
          variant="contained"
          href={LEAD_FORM_URL}
          target="_blank"
          rel="noopener"
        >
          Get in touch
        </Button>
        <Button size="small" variant="outlined" href={PHONE_HREF}>
          {PHONE_LABEL}
        </Button>
      </Stack>
    </Paper>
  );
}
